/**
 * @generated SignedSource<<2ac329da81149c1c3666eddb688657bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment$data = {
  readonly by: {
    readonly displayName: string | null | undefined;
  } | null | undefined;
  readonly when: string | null | undefined;
  readonly " $fragmentType": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment";
};
export type useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment$key = {
  readonly " $data"?: useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "displayName"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "when"
    }
  ],
  "type": "Version"
};

(node as any).hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";

export default node;
